'use strict';

import ngResource from 'angular-resource';

class DistStockService {
  constructor($resource) {
    'ngInject';
    this.api = $resource(
      '/api/dist_stock', {},
      {index: {method: 'GET', isArray: true}}
    );

    this.oem_api = $resource(
      '/api/oem/dist_stock', {},
      {
        index: {method: 'GET', isArray: false},
        count: {method: 'GET', isArray: false, params: {count: true}}
      }
    );

    this.manage_api = $resource(
      '/:mode/api/dist_stock',
      { mode: '@mode' },
      {
        index: {method: 'GET', isArray: true},
        create: {method: 'POST', isArray: false}
      }
    );
  }
}

export default angular.module('leptonApp.DistStockService', ['ngResource'])
  .service('DistStockService', ['$resource', DistStockService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/dist_stock/dist_stock.service.js